import httpCommon from "./http-common";
import { httpFormData } from "./http-common";
import { AxiosProgressEvent } from "axios";

// Get all bill items
const getAllBills = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/bills/${businessId}?skip=${skip}&limit=${limit}`);
};

const getAllRecentBills = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/recentBills/${businessId}?skip=${skip}&limit=${limit}`);
};

const getBillsByPendingStatus = (businessId: number) => {
  return httpCommon.get(`/v1/get/billsByPendingStatus/${businessId}`);
};

const getBillsShowingOnlyStatus = (businessId: number) => {
  return httpCommon.get(`/v1/get/billsShowingOnlyStatus/${businessId}`);
};

// Get bill item count
const getAllBillsCount = () => {
  return httpCommon.get("/v1/get/count/bills");
};

const getBillsTotalValue = () => {
  return httpCommon.get("/v1/get/totalValue/bills");
};

const getBillById = (id: number) => {
  return httpCommon.get(`/v1/get/bill/${id}`);
};

const getBillByPublicId = (publicId: string) => {
  return httpCommon.get(`/v1/get/bill/${publicId}`);
};

// Create bill
const createBill = (data: any, businessId: number, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void) => {
  // Use httpFormData if formData is being sent
  if (data instanceof FormData) {
    return httpFormData.post(`/v1/add/bill/${businessId}`, data, {
      onUploadProgress: onUploadProgress
    });
  }
  return httpCommon.post(`/v1/add/bill/${businessId}`, data, {
    onUploadProgress: onUploadProgress
  });
};

// Update specific bill item
const updateSpecificBill = (publicId: string, data: any, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void) => {
  // Use httpFormData if formData is being sent
  if (data instanceof FormData) {
    return httpFormData.put(`/v1/update/bill/${publicId}`, data, {
      onUploadProgress: onUploadProgress
    });
  }
  return httpCommon.put(`/v1/update/bill/${publicId}`, data, {
    onUploadProgress: onUploadProgress
  });
};

// Delete bill
const deleteBill = (id: number) => {
  return httpCommon.delete(`/v1/delete/bill/${id}`);
};

// Admin functions
const getAllBillsAsAdminUser = (skip = 0) => {
  return httpCommon.get(`/v1/admin/get/bills?skip=${skip}`);
};

const getAllBillsCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/bills");
};

const getBillsTotalValueAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/totalValue/bills");
};

const BillsService = {
    getAllBills,
    getAllRecentBills,
    getAllBillsCount,
    getBillsByPendingStatus,
    getBillsShowingOnlyStatus,
    getBillsTotalValue,
    getBillById,
    getBillByPublicId,
    createBill,
    updateSpecificBill,
    deleteBill,
    getAllBillsAsAdminUser,
    getAllBillsCountAsAdminUser,
    getBillsTotalValueAsAdminUser,
};
export default BillsService;
